<template>
  <button
    ref="blockButton"
    role="button"
    :aria-label="`It's a mystery block... ${selectedTeaser}`"
    :aria-pressed="isBopping"
    :class="['question-mark-block-button link flat', { questionMarkBlockBounce: isBopping }]"
    :data-balloon-pos="isShowingTooltip && !hasHitBopLimit ? 'up' : null"
    :style="buttonStyle"
    tabindex="-1"
    @click="handleBop"
  >
    <span
      v-if="!hasHitBopLimit"
      :class="`fa-${blockSize}`"
    >
      <font-awesome-icon
        v-if="isShowingHoverInitially"
        :icon="$v6.duotone.faBlockQuestion"
        fixed-width
      />
      <span
        v-else
        class="swap-icons position-relative display-inline-block"
        style="line-height: 0"
      >
        <font-awesome-icon
          :icon="$v6.solid.faBlockQuestion"
          class="initial-icon"
          fixed-width
        />
        <font-awesome-icon
          :icon="$v6.duotone.faBlockQuestion"
          class="hover-icon z-4"
          fixed-width
        />
      </span>
      <span
        v-show="isShowingCoin"
        class="question-mark-block-button-coin questionMarkCoinkBounce position-absolute center-all z-foreground"
        :style="{ '--fa-animation-duration': '0.5s', 'color': coinColor }"
      >
        <font-awesome-icon
          :icon="$v6.solid.faCoinFront"
          style="font-size: 0.5em"
          flip
        />
      </span>
    </span>
    <font-awesome-icon
      v-else
      :icon="$v6.duotone.faBlock"
      fixed-width
      :size="blockSize"
    />
  </button>
</template>

<script>
  import sample from 'lodash/sample'

  const teasers = ["let's-a go!", 'here we go!', 'wahoo!', 'mamma mia!']

  export default {
    name: 'Block',

    props: {
      blockColor: String,
      blockHoverPrimaryColor: String,
      blockHoverSecondaryColor: String,
      blockSize: String,
      coinColor: String,
      hasHitBopLimit: Boolean,
      isShowingHoverInitially: Boolean
    },

    data() {
      return {
        bopCount: 0,
        bopLimit: Math.floor(Math.random() * 100) + 1,
        isBopping: false,
        isShowingCoin: false,
        isShowingTooltip: true,
        selectedTeaser: sample(teasers)
      }
    },

    computed: {
      buttonStyle() {
        return {
          '--button-color': this.blockColor,
          '--button-margin-bottom': '0',
          '--button-padding': '0',
          '--fa-primary-color': this.blockHoverPrimaryColor,
          '--fa-secondary-color': this.blockHoverSecondaryColor,
          '--fa-secondary-opacity': '1',
          '--question-mark-block-bounce-duration': '0.25s',
          '--question-mark-coin-bounce-duration': '0.5s',
          'lineHeight': '1'
        }
      }
    },

    methods: {
      handleBop() {
        if (this.bopCount >= this.bopLimit) {
          this.$emit('bop', {
            bopCount: this.bopCount,
            bopLimitReached: true
          })
          return
        }

        this.bopCount++
        this.triggerCoinBounce()
        this.triggerBlockBounce()
        this.$emit('bop', {
          bopCount: this.bopCount,
          bopLimitReached: this.bopCount >= this.bopLimit
        })
      },

      triggerBlockBounce() {
        this.isBopping = true
        setTimeout(() => {
          this.isBopping = false
        }, 250)
      },

      triggerCoinBounce() {
        this.isShowingCoin = true
        this.isShowingTooltip = false

        setTimeout(() => {
          this.isShowingCoin = false

          // delay before allowing tooltip to return
          setTimeout(() => {
            if (!this.hasHitBopLimit) {
              this.isShowingTooltip = true
            }
          }, 5000)
        }, 500)
      }
    }
  }
</script>
